import { Link, Text } from "@chakra-ui/react";
import { formatTime } from "constants/commonFunctions";
import { formatDateToDDMONTHNAMEYYYY } from "utils/common";

export const userUsageColumns = [
  {
    Header: "User Name",
    accessor: "user_data.first_name",
    Cell: ({ value, row }) => (
      <Text>
        {value} {row.original.user_data.last_name} +{" "}
        {row.original.user_data.role}
      </Text>
    ),
  },
  {
    Header: "Plan Name",
    accessor: "plan_data.name",
  },
  {
    Header: "Viewed Number",
    accessor: "viewed_user_data",
    Cell: ({ value }) => {
      const name = `${value?.first_name || ""} ${value?.last_name || ""}`.trim();
      const phone = value?.phone;
      if (!name && !phone) return <Text>-</Text>;
      return (
        <Text>
          {name || "-"}
          {phone ? ` (${phone})` : ""}
        </Text>
      );
    },
  },
  {
    Header: "Key",
    accessor: "key",
  },
  {
  Header: "SLUG/LABEL",
  accessor: "slug_url",
  Cell: ({ value, row }) => {
    const { owner_id, user_data, ref_type, ref_id, label, requirement_id } = row.original;

    const renderLink = (href) => (
      <Link
        href={href}
        target="_blank"
        rel="noreferrer"
        fontWeight="600"
        fontSize="11px"
        style={{ whitespace: "nowrap", textAlign: "center" }}
      >
        {value || label || "-"}
      </Link>
    );
    if (ref_type === "admin_leads") {
      return renderLink(`/#/admin/user-requirements?requirement_id=${requirement_id}`);
    } else if (ref_type === "leads") {
      const isOwner = owner_id === user_data?._id;
      const href = isOwner
        ? `/#/admin/users/${owner_id}?adId=${ref_id}`
        : `/#/admin/user-activity?search_text=${user_data?.phone}`;
      return renderLink(href);
    }else{
    return value ? (
      renderLink(`${process.env.REACT_APP_HEXAHOME_BASE_URL}/property-details/${value}`)
    ) : (
      <p style={{ fontSize: "11px", textAlign: "center", fontWeight: 600 }}>
        {label || "-"}
      </p>
    );
  }
  },
  },
  {
    Header: "Ref Type",
    accessor: "ref_type",
  },
  {
    Header: "Created At",
    accessor: "created_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
  {
    Header: "Updated At",
    accessor: "updated_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
  {
    Header: "Phone",
    accessor: "user_data.phone",
  },
];
